<template>
    <footer class="footer container">
        <div class="footer__copyright">
            Сделано на <a target="_blank" href="https://fitbase.io">fitbase.io</a>
        </div>

        <div class="flex-container rules">
          <div class="rules-flex-container">
              <div v-if="clubSettings?.modules?.payment_rules?.enable">
                <a :href="clubSettings.modules.payment_rules.link">
                  Правила оплаты
                </a>
              </div>
              <div v-if="clubSettings?.modules?.club_rules?.enable">
                <a :href="clubSettings.modules.club_rules.link">
                  Правила клуба
                </a>
              </div>
          </div>
          <div class="rules-flex-container" style="margin-left: auto">
            <img src="../../../assets/img/mir.png" alt="" style="margin-right: 20px">
            <img src="../../../assets/img/mir-accept.png" alt="">
          </div>
        </div>

        <div class="flex-container legal-entity">
            <div>
                <p v-if="clubSettings?.lk?.email">
                  <a :href="'mailto:' + clubSettings.lk.email">
                    {{ clubSettings.lk.email }}
                  </a>
                </p>
                <p v-if="clubSettings?.lk?.legal_entity?.name">
                  <span>
                    {{ clubSettings.lk.legal_entity.name }}
                  </span>
                  <span v-if="clubSettings?.lk?.legal_entity?.inn">
                    , ИНН {{ clubSettings.lk.legal_entity.inn }}
                  </span>
                </p>
                <p v-if="clubSettings?.lk?.legal_entity?.address">
                  {{ clubSettings.lk.legal_entity.address }}
                </p>
            </div>
            <div class="offer-container">
                <div v-if="clubSettings?.modules?.offer?.link">
                  <a :href="clubSettings.modules.offer.link">
                    Публичная оферта
                  </a>
                </div>
                <div v-if="clubSettings?.modules?.processing_personal_data?.link">
                  <a :href="clubSettings.modules.processing_personal_data.link">
                    Политика конфиденциальности
                  </a>
                </div>
            </div>
        </div>
    </footer>

    <success-modal />
    <item-modal-cancel-subscription v-if="cancelItemSubscription" :item="cancelItemSubscription"/>
    <shop-modal-item/>
    <shop-modal-payment v-if="paymentItem"/>
    <shop-modal-success v-if="successPayment"/>
    <modal-preloader v-if="preloaderModal"/>
</template>

<script>
  import ShopModalItem from "../../../components/shop/ShopModalItem";
  import ShopModalPayment from "../../../components/shop/ShopModalPayment";
  import ModalPreloader from "../../../components/ModalPreloader";
  import ShopModalSuccess from "../../../components/shop/ShopModalSuccess";
  import ItemModalCancelSubscription from "../../../components/ItemModalCancelSubscription.vue";
  import SuccessModal from "@/components/SuccessModal.vue";
  export default {
    name: 'FooterLayout',
      components: {SuccessModal, ItemModalCancelSubscription, ShopModalSuccess, ModalPreloader, ShopModalPayment, ShopModalItem},
      computed: {
          preloaderModal: function() {
              return this.$store.getters.showModalPreloader;
          },
          paymentItem: function() {
              return this.$store.getters.shopPaymentModal;
          },
          successPayment: function() {
              return this.$store.getters.shopSuccessModal;
          },
          cancelItemSubscription: function(){
              return this.$store.getters.itemCancelSubscriptionModal;
          },
          clubSettings: function () {
            try {
              console.log(this.$store.getters.settings);
              return this.$store.getters.settings;
            } catch (e) {
              return null
            }
          }
      }
  }
</script>
